import api from './api';

const ORDERS_ENDPOINTS = {
  GET_ORDERS: '/orders',
  GET_ORDER: '/orders',
  CREATE_ORDER: '/orders',
  UPDATE_ORDER: '/orders',
  CANCEL_ORDER: '/orders/cancel',
  TRACK_ORDER: '/orders/track',
  GET_INVOICE: '/orders/invoice',
  RETURN_ORDER: '/orders/return',
  GET_RETURNS: '/orders/returns',
  GET_SHIPPING: '/orders/shipping',
  GET_PAYMENT: '/orders/payment',
  CONFIRM_PAYMENT: '/orders/payment/confirm',
  GET_ORDER_STATUS: '/orders/status',
  GET_ORDER_HISTORY: '/orders/history'
};

export const createOrder = async (orderData) => {
  try {
    const response = await api.post(ORDERS_ENDPOINTS.CREATE_ORDER, orderData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrders = async (params = {}) => {
  try {
    const response = await api.get(ORDERS_ENDPOINTS.GET_ORDERS, { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrder = async (orderId) => {
  try {
    const response = await api.get(`${ORDERS_ENDPOINTS.GET_ORDER}/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateOrder = async (orderId, orderData) => {
  try {
    const response = await api.put(`${ORDERS_ENDPOINTS.UPDATE_ORDER}/${orderId}`, orderData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelOrder = async (orderId, reason) => {
  try {
    const response = await api.post(`${ORDERS_ENDPOINTS.CANCEL_ORDER}/${orderId}`, { reason });
    return response;
  } catch (error) {
    throw error;
  }
};

export const trackOrder = async (orderNumber, email) => {
  try {
    const response = await api.get(ORDERS_ENDPOINTS.TRACK_ORDER, {
      params: { orderNumber, email }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getInvoice = async (orderId) => {
  try {
    const response = await api.get(`${ORDERS_ENDPOINTS.GET_INVOICE}/${orderId}`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const returnOrder = async (orderId, returnData) => {
  try {
    const response = await api.post(`${ORDERS_ENDPOINTS.RETURN_ORDER}/${orderId}`, returnData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getReturns = async () => {
  try {
    const response = await api.get(ORDERS_ENDPOINTS.GET_RETURNS);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getShippingInfo = async (orderId) => {
  try {
    const response = await api.get(`${ORDERS_ENDPOINTS.GET_SHIPPING}/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPaymentInfo = async (orderId) => {
  try {
    const response = await api.get(`${ORDERS_ENDPOINTS.GET_PAYMENT}/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const confirmPayment = async (orderId, paymentData) => {
  try {
    const response = await api.post(`${ORDERS_ENDPOINTS.CONFIRM_PAYMENT}/${orderId}`, paymentData);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderStatus = async (orderId) => {
  try {
    const response = await api.get(`${ORDERS_ENDPOINTS.GET_ORDER_STATUS}/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderHistory = async () => {
  try {
    const response = await api.get(ORDERS_ENDPOINTS.GET_ORDER_HISTORY);
    return response;
  } catch (error) {
    throw error;
  }
};

export const reorder = async (orderId) => {
  try {
    const response = await api.post(`/orders/reorder/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const rateOrder = async (orderId, rating, review) => {
  try {
    const response = await api.post(`/orders/rate/${orderId}`, { rating, review });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTrackingTimeline = async (orderId) => {
  try {
    const response = await api.get(`/orders/tracking/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getEstimatedDelivery = async (orderId) => {
  try {
    const response = await api.get(`/orders/delivery/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const scheduleDelivery = async (orderId, deliveryDate, timeSlot) => {
  try {
    const response = await api.post(`/orders/delivery/schedule/${orderId}`, {
      deliveryDate,
      timeSlot
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDeliverySlots = async (orderId) => {
  try {
    const response = await api.get(`/orders/delivery/slots/${orderId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export default {
  createOrder,
  getOrders,
  getOrder,
  updateOrder,
  cancelOrder,
  trackOrder,
  getInvoice,
  returnOrder,
  getReturns,
  getShippingInfo,
  getPaymentInfo,
  confirmPayment,
  getOrderStatus,
  getOrderHistory,
  reorder,
  rateOrder,
  getTrackingTimeline,
  getEstimatedDelivery,
  scheduleDelivery,
  getDeliverySlots
};